import React from "react";

interface FunctionalAbilitySparklineProps {
  values: number[];
  color: string;
  labels?: string[];
}

export const FunctionalAbilitySparkline: React.FC<
  FunctionalAbilitySparklineProps
> = ({ values, color, labels }) => {
  const w = 64;
  const h = 22;
  const pad = 4;
  const minVal = 1;
  const maxVal = 6;
  const range = maxVal - minVal;

  const toY = (v: number) =>
    pad + (1 - (v - minVal) / range) * (h - pad * 2);

  const points = values.map((v, i) => ({
    x: pad + (i / Math.max(values.length - 1, 1)) * (w - pad * 2),
    y: toY(v),
  }));

  const polyline = points.map((p) => `${p.x},${p.y}`).join(" ");

  return (
    <svg
      className="inline-block align-middle"
      width={w}
      height={h}
      viewBox={`0 0 ${w} ${h}`}
    >
      <polyline
        points={polyline}
        fill="none"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {points.map((p, i) => (
        <circle key={`dot-${i}`} cx={p.x} cy={p.y} r={2.5} fill={color} />
      ))}
      {points.map((p, i) => (
        <g key={`hit-${i}`}>
          <title>{labels?.[i] ?? values[i]}</title>
          <rect
            x={p.x - 4}
            y={0}
            width={8}
            height={h}
            fill="transparent"
          />
        </g>
      ))}
    </svg>
  );
};
